import React, { useLayoutEffect } from "react";
import { BrookshireBrotherLogoWithTagline, DocNRxBrochure } from "../../../../../assets";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";
import VEBDocandRxImage from "../../../../../assets/VEBPlanImages/VEBCallToDocsImage.avif";
import "./docAndRx.scss";

const DocAndRxPlan: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="doc-and-rx-plan-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Call Up To Docs</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={BrookshireBrotherLogoWithTagline} alt="" />
					</div>
					<div className="plan-description">
						<ul>
							<h3>When To Use</h3>
							<li>
								Call Up A Doc does not replace your primary care physician. Our goal is to provide you
								with convenient, affordable healthcare, when you need it most.
							</li>
							<li> When you need care now </li>
							<li> If you need a second opinion on lab results </li>
							<li> Ifyou have a health related questions and Just need professional guidance </li>
							<li> On vacation, a business trip, or away from home </li>
							<li>
								{""}
								If you&#39;re considering the ER or urgent care center for a non-emergency issue{" "}
							</li>
							<li> Forshort-term prescription refills</li>
						</ul>
					</div>
				</div>
				<div className="right-section">
					<img src={VEBDocandRxImage} alt="VEBDocandRxImage" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={DocNRxBrochure} />
			</div>
		</div>
	);
};

export default DocAndRxPlan;
